import { render } from "./RendezVous.vue?vue&type=template&id=053f7825"
import script from "./RendezVous.vue?vue&type=script&lang=js"
export * from "./RendezVous.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__